import { UserCheck } from "lucide-react";
import { EmptyState } from "@/components/shared/empty-state";
import { PageHeader } from "@/components/shared/page-header";

export function HROnboardingPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        title="Onboarding"
        description="New hires and where they are in getting set up."
      />
      <EmptyState
        icon={UserCheck}
        heading="Nothing tracked here yet"
        description="This page is ready to build out — onboarding checklists, new hire status, whatever you want tracked."
      />
    </div>
  );
}
